import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faPlus, faExchangeAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import baseURL from '../../url';
import { useData } from '../../DataContext';

const btnIcon = (color) => ({
    background: 'transparent',
    border: 'none',
    color,
    fontSize: '15px',
    cursor: 'pointer',
    padding: '4px',
});

export default function MetodosTransferencia() {
    const { metodos, cargarMetodos } = useData();
    const [nuevo, setNuevo] = useState('');
    const [editando, setEditando] = useState(null);
    const [editNombre, setEditNombre] = useState('');
    const [enviando, setEnviando] = useState(false);

    const agregar = async () => {
        const nombre = nuevo.trim();
        if (!nombre) { toast.error('Ingresá un nombre'); return; }
        setEnviando(true);
        const fd = new FormData();
        fd.append('nombre', nombre);
        try {
            const res = await fetch(`${baseURL}/metodosPost.php`, { method: 'POST', body: fd });
            const data = await res.json();
            if (data.mensaje) { toast.success(data.mensaje); setNuevo(''); cargarMetodos(); }
            else { toast.error(data.error || 'Error'); }
        } catch (e) { toast.error('Error de conexión'); }
        setEnviando(false);
    };

    const eliminar = async (idMetodo) => {
        try {
            const res = await fetch(`${baseURL}/metodosDelete.php?idMetodo=${idMetodo}`, { method: 'DELETE' });
            const data = await res.json();
            if (data.mensaje) { toast.success(data.mensaje); cargarMetodos(); }
            else { toast.error(data.error || 'Error'); }
        } catch (e) { toast.error('Error de conexión'); }
    };

    const guardarEdicion = async (idMetodo) => {
        const nombre = editNombre.trim();
        if (!nombre) { toast.error('Ingresá un nombre'); return; }
        try {
            const res = await fetch(`${baseURL}/metodosPut.php?idMetodo=${idMetodo}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre }),
            });
            const data = await res.json();
            if (data.mensaje) { toast.success(data.mensaje); setEditando(null); cargarMetodos(); }
            else { toast.error(data.error || 'Error'); }
        } catch (e) { toast.error('Error de conexión'); }
    };

    return (
        <div style={{ background: '#fff', border: '1px solid #e9ecef', borderRadius: '12px', padding: '18px', marginBottom: '16px' }}>
            <h4 style={{ margin: '0 0 12px', fontSize: '15px', color: '#212529' }}>
                <FontAwesomeIcon icon={faExchangeAlt} style={{ color: 'var(--color1)', marginRight: '8px' }} />
                Métodos de transferencia
            </h4>

            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
                <input
                    type="text"
                    placeholder="Nuevo método (ej. Nequi)"
                    value={nuevo}
                    onChange={(e) => setNuevo(e.target.value)}
                    style={{ flex: 1, minWidth: '180px', padding: '9px 12px', border: '1px solid #dee2e6', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
                <button
                    onClick={agregar}
                    disabled={enviando}
                    style={{ padding: '9px 16px', background: 'var(--color1)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Agregar
                </button>
            </div>

            {metodos.length === 0 ? (
                <p style={{ color: '#6c757d', fontSize: '13px' }}>Sin métodos configurados</p>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {metodos.map(m => (
                        <div key={m.idMetodo} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', border: '1px solid #f0f0f0', borderRadius: '8px', background: '#f8f9fa' }}>
                            {editando === m.idMetodo ? (
                                <>
                                    <input
                                        type="text"
                                        value={editNombre}
                                        onChange={(e) => setEditNombre(e.target.value)}
                                        style={{ flex: 1, padding: '6px 10px', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '14px' }}
                                    />
                                    <button onClick={() => guardarEdicion(m.idMetodo)} style={btnIcon('var(--color1)')} title="Guardar">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </button>
                                    <button onClick={() => setEditando(null)} style={btnIcon('#6c757d')} title="Cancelar">
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <span style={{ flex: 1, fontSize: '14px', fontWeight: 500, color: '#212529' }}>{m.nombre}</span>
                                    <button onClick={() => { setEditando(m.idMetodo); setEditNombre(m.nombre); }} style={btnIcon('#0d6efd')} title="Editar">
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button onClick={() => eliminar(m.idMetodo)} style={btnIcon('#dc3545')} title="Eliminar">
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
